import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=41c77739&scoped=true&"
import script from "./tag.vue?vue&type=script&lang=ts&"
export * from "./tag.vue?vue&type=script&lang=ts&"
import style0 from "./tag.scss?vue&type=style&index=0&id=41c77739&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c77739",
  null
  
)

export default component.exports